"use client"

import { StoryCardDto } from "api"
import { useInView } from "react-intersection-observer"
import { trackArticleClick } from "utils/gtm"
import ChevronIcon from "./ChevronIcon"
import { formatStoryDate } from "./formatStoryDate"
import {
  CardBar,
  CardBody,
  CardCategory,
  CardImg,
  CardLink,
  CardTag,
  CardTitle,
  DesktopOnly,
  Meta,
  MetaDot,
  MobileOnly,
  ReadMore,
} from "./storiesSection.styled"

type Props = { story: StoryCardDto; revealDelay?: number }

const StoryCard = ({ story, revealDelay = 0 }: Props) => {
  const { ref, inView } = useInView({ triggerOnce: true })
  return (
    <CardLink
      ref={ref}
      className={`be-reveal${inView ? " in-view" : ""}`}
      style={{ animationDelay: `${revealDelay}ms` }}
    >
      {/* RTL: image rendered before the body on mobile (image-top) and after it on
          desktop (so natural RTL flow puts the image on the LEFT) — DOM order, no reverse. */}
      {story.image?.imageUrl && (
        <MobileOnly>
          <CardImg
            src={story.image.imageUrl}
            alt={story.image.alt ?? ""}
            loading="lazy"
          />
        </MobileOnly>
      )}
      <CardBody>
        {story.category && (
          <CardTag>
            <CardBar />
            <CardCategory dir="auto">{story.category}</CardCategory>
          </CardTag>
        )}
        {story.title && <CardTitle dir="auto">{story.title}</CardTitle>}
        {(story.readTime || story.date) && (
          <Meta>
            {story.date && <span dir="auto">{formatStoryDate(story.date)}</span>}
            {story.readTime && story.date && <MetaDot />}
            {story.readTime && <span dir="auto">{story.readTime}</span>}
          </Meta>
        )}
        <ReadMore
          href={story.url || "#"}
          onClick={() => trackArticleClick(story.title ?? "")}
        >
          לקריאה מלאה
          <ChevronIcon size={12} />
        </ReadMore>
      </CardBody>
      {story.image?.imageUrl && (
        <DesktopOnly>
          <CardImg
            src={story.image.imageUrl}
            alt={story.image.alt ?? ""}
            loading="lazy"
          />
        </DesktopOnly>
      )}
    </CardLink>
  )
}

export default StoryCard
